module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Contacts","cont-text":"I\u0027m open to any offers and willing to relocate."},"pt":{"title":"Contactos","cont-text":"Estou aberto a todas a oportunidades e disposto a relocar-me"},"ja":{"title":"連絡先"}}')
  delete Component.options._Ctor
}
